import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { TokenService } from '../services/token.service';
import { AuthService } from '../services/auth.service';

/**
 * Functional route guard.
 * If the user has a valid JWT → allow navigation.
 * Otherwise → start the full OAuth2 Authorization Code flow
 * (full-page redirect to the auth server).
 */
export const authGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  if (!tokenService.isTokenExpired()) {
    return true;
  }

  tokenService.clear();
  // Full-page redirect to auth server's /oauth2/authorize
  authService.startAuthFlow();
  return false;
};
